export const aboutData = {
  brandIntro: {
    title: '关于开云',
    subtitle: '以科技驱动服务，以信任连接未来',
    description: '开云平台成立于2014年，是一家致力于通过科技创新为用户提供优质数字服务的综合性平台。十余年来，我们始终秉持"用户至上、创新驱动、诚信为本"的核心价值观，持续深耕数字服务领域，现已发展成为拥有超过500万活跃用户、服务覆盖全国的行业领先平台。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxurious%20corporate%20headquarters%20building%20at%20golden%20hour%2C%20warm%20amber%20sunset%20light%20reflecting%20on%20glass%20facade%2C%20elegant%20minimalist%20architecture%20with%20clean%20geometric%20lines%2C%20professional%20corporate%20atmosphere%2C%20dark%20sophisticated%20tone%20with%20warm%20golden%20highlights&width=1200&height=700&seq=kaiyun-about-brand&orientation=landscape',
  },
  mission: {
    vision: '成为最受用户信赖的数字服务平台',
    mission: '以科技创新为用户创造卓越价值，以诚信服务构建可持续的数字生态',
    values: [
      { title: '用户至上', description: '始终将用户需求和体验放在首位，用心倾听每一个声音' },
      { title: '创新驱动', description: '持续探索前沿技术，以创新引领行业发展，驱动服务升级' },
      { title: '诚信为本', description: '坚持透明、公正、合规的运营准则，以真诚赢得信任' },
      { title: '合作共赢', description: '与合作伙伴携手共进，构建开放互利的生态共同体' },
    ],
  },
  milestones: [
    { year: '2014', title: '扬帆起航', description: '开云平台正式成立，初始团队不到50人，怀揣"用科技连接世界"的梦想起步。' },
    { year: '2016', title: '用户突破百万', description: '凭借优质的产品体验和口碑传播，平台注册用户数突破100万，迈入快速发展期。' },
    { year: '2018', title: '技术全面升级', description: '完成核心系统架构重构，引入分布式云服务和AI技术，平台稳定性与智能化水平大幅提升。' },
    { year: '2020', title: '服务生态扩展', description: '推出多元化服务矩阵，覆盖娱乐、体育、生活等多个领域，构建全方位的数字服务生态。' },
    { year: '2022', title: '用户突破500万', description: '平台用户规模突破500万，服务覆盖全国300+城市，成为行业领先的综合性数字服务平台。' },
    { year: '2024', title: 'AI战略启航', description: '全面启动AI赋能战略，智能推荐、智能风控等核心系统上线，开启智能化发展的新篇章。' },
  ],
  reputation: {
    title: '品牌信誉',
    subtitle: '以实力赢得认可，以诚信铸就口碑',
    certifications: [
      { name: '国家高新技术企业认证', icon: 'ri-award-line', description: '通过国家高新技术企业认定，彰显技术创新实力' },
      { name: 'ISO 27001信息安全管理', icon: 'ri-shield-check-line', description: '通过国际信息安全管理体系认证，数据安全有保障' },
      { name: '可信云服务认证', icon: 'ri-cloud-line', description: '获得可信云服务认证，云服务能力达到行业高标准' },
      { name: 'AAA级信用企业', icon: 'ri-medal-line', description: '获评AAA级信用企业，诚信经营获得权威认可' },
    ],
    awards: [
      { year: '2024', name: '年度最佳用户体验平台', org: '中国互联网协会' },
      { year: '2023', name: '数字服务创新奖', org: '中国信息产业商会' },
      { year: '2022', name: '最具成长力品牌', org: '品牌中国产业联盟' },
      { year: '2021', name: '科技创新先锋企业', org: '中国科技产业化促进会' },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '我们随时准备为您提供帮助',
    address: '深圳市南山区科技园南路88号开云大厦',
    phone: '400-888-8888',
    email: 'service@kaiyun.com',
    workingHours: '周一至周日 全天候服务（7×24小时）',
    socialLinks: [
      { name: '微信公众号', icon: 'ri-wechat-line' },
      { name: '官方微博', icon: 'ri-weibo-line' },
      { name: '官方社区', icon: 'ri-chat-smile-2-line' },
    ],
  },
};